import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/logo_black.png'
import _imports_1 from '@/assets/images/12.png'
import _imports_2 from '@/assets/images/79.png'
import _imports_3 from '@/assets/images/80.png'


const _hoisted_1 = { class: "head_box" }
const _hoisted_2 = { class: "fs" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  src: _imports_1,
  alt: "",
  class: "avatar"
}
const _hoisted_5 = { class: "nick ell1" }
const _hoisted_6 = { class: "downBox" }
const _hoisted_7 = {
  key: 0,
  class: "dbContent"
}

import SelectLanguage from '@/components/SelectLanguage.vue';
import { computed, ref } from 'vue';
import Container from './Container.vue';
import { DelConfrimType } from '@/types/global';
import DelConfrim from '@/components/DelConfrim.vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/store/user';
import { useI18n } from 'vue-i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'Chead',
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();

const { t } = useI18n();

const showPersonMore = ref(false);

const delConfrim = ref<DelConfrimType>();

const userInfo = computed(() => userStore.userInfo);

function logout() {
	delConfrim.value?.show(t('确定退出系统吗？'), () => {
		userStore.loginOut();
		router.replace('/login');
	});
}

function toScreenFull() {
	const element = document.documentElement; // 整个<html>元素，即全页面
	// 或 const element = document.getElementById("myVideo"); // 指定元素

	if (userStore.isOpenScreenFull) {
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document.webkitExitFullscreen) {
			// Safari 和旧版 Chrome
			document.webkitExitFullscreen();
		} else if (document.msExitFullscreen) {
			// IE/Edge
			document.msExitFullscreen();
		} else if (document.mozCancelFullScreen) {
			// Firefox 旧版
			document.mozCancelFullScreen();
		}
	} else {
		// 发起全屏请求
		if (element.requestFullscreen) {
			element.requestFullscreen();
		} else if (element.webkitRequestFullscreen) {
			// Safari 和旧版 Chrome
			element.webkitRequestFullscreen();
		} else if (element.msRequestFullscreen) {
			// IE/Edge
			element.msRequestFullscreen();
		} else if (element.mozRequestFullScreen) {
			// Firefox 旧版
			element.mozRequestFullScreen();
		}
	}
}

window.addEventListener('click', () => {
	showPersonMore.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_CaretBottom = _resolveComponent("CaretBottom")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Container, {
        class: "f ac",
        style: {"height":"100%"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "logo",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/home/gailan')))
          }),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w144" }, null, -1)),
          _createVNode(_component_RouterLink, {
            class: "link",
            to: "/home/gailan"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("概览")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, {
            class: "link",
            to: "/home/project"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("项目")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, {
            class: _normalizeClass(["link", {cur: ['/home/device/jiaohuanji','/home/device/map'].includes(_ctx.$route.path)}]),
            to: "/home/device/tuopu"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("设备")), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_RouterLink, {
            class: _normalizeClass(["link", { cur: ['/home/weihu/warnConfig'].includes(_ctx.$route.path) }]),
            to: "/home/weihu/warnRecard"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("维护")), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "f1" }, null, -1)),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(SelectLanguage)
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "shu" }, null, -1)),
          _createElementVNode("div", {
            class: "person",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => {showPersonMore.value = true;}, ["stop"]))
          }, [
            _withDirectives(_createElementVNode("img", {
              src: userInfo.value.avatar,
              alt: "",
              class: "avatar"
            }, null, 8, _hoisted_3), [
              [_vShow, userInfo.value.avatar]
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
              [_vShow, !userInfo.value.avatar]
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(userInfo.value.nickname), 1),
            _createVNode(_component_el_icon, { color: "#555" }, {
              default: _withCtx(() => [
                _createVNode(_component_CaretBottom)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              (showPersonMore.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: "f ac pointer",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {_ctx.$router.push('/home/my/base'), showPersonMore.value = false;}, ["stop"]))
                    }, [
                      _cache[4] || (_cache[4] = _createElementVNode("img", {
                        src: _imports_2,
                        alt: ""
                      }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("个人设置")), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "f ac pointer",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (logout(), showPersonMore.value = false), ["stop"]))
                    }, [
                      _cache[5] || (_cache[5] = _createElementVNode("img", {
                        src: _imports_3,
                        alt: ""
                      }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("退出登录")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(DelConfrim, {
      ref_key: "delConfrim",
      ref: delConfrim
    }, null, 512)
  ]))
}
}

})